export const language = {
    title_charge_zinli_crypto: "title_charge_zinli_crypto",
    first_step_title: "first_step_title",
    second_step_title: "second_step_title",
    email: "email",
    phone: "phone",
    enter_number: "enter_number",
    amount: "amount",
    next: "next",
    first_term_conditions: "first_term_conditions",
    second_term_conditions: "second_term_conditions",
    term_conditions: "term_conditions",
    title_home: "title_home",
    title_first_button: "title_first_button",
    title_second_button: "title_second_button",
    title_charge_pf_crypto: "title_charge_pf_crypto",
    back_to_init: "back_to_init",
    title_login: "title_login",
    scan_qr_pay_app: "scan_qr_pay_app",
    password: "password",
    login: "login",
    enter_amount: "enter_amount",
    balanace_available: "balanace_available",
    title_sdk_pay_pf: "title_sdk_pay_pf",
    download_receipt: "download_receipt",
    proof_recurrent: "proof_recurrent",
    proof_payment: "proof_payment",
    proof_refunded: "proof_refunded",
    proof_parcial_refunded: "proof_parcial_refunded",
    proof_captured: "proof_captured",
    proof_recharge: "proof_recharge",
    operation_code: "operation_code",
    date_hour: "date_hour",
    payment_method: "payment_method",
    details: "details",
    state: "state",
    total: "total",
    method_crypto: "method_crypto",
    pending: "pending",
    aproved: "aproved",
    amount_recharged: "amount_recharged",
    commission: "commission",
    depend_network: "depend_network",
    state_suppler: "state_suppler",
    tx_id: "tx_id",
    disclaimer_amount_tax: "disclaimer_amount_tax",
    title_home_cryptofacil: "title_home_cryptofacil",
    subtitle_home_cryptofacil: "subtitle_home_cryptofacil",
    signup: "signup",
    full_name: "full_name",
    enter_full_name: "enter_full_name",
    create_account: "create_account",
    do_you_has_account: "do_you_has_account",
    enter: "enter",
    title_signup: "title_signup",
    title_signup_validation_code: "title_signup_validation_code",
    subtitle_signup: "subtitle_signup",
    subtitle_signup_validation_code: "subtitle_signup_validation_code",
    not_get_verification_code: "not_get_verification_code",
    resend: "resend",
    validation_code: "validation_code",
    validate_characters_max: "validate_characters_max",
    validate_email: "validate_email",
    do_not_you_has_account: "do_not_you_has_account",
    title_login_cryptofacil: "title_login_cryptofacil",
    title_validation_code_login_cf: "title_validation_code_login_cf",
    subtitle_validation_code_login_cf: "subtitle_validation_code_login_cf",
    subtitle_login_cryptofacil: "subtitle_login_cryptofacil",
    hello: "hello",
    connect_account_zinli: "connect_account_zinli",
    description_connect_zinli_one: "description_connect_zinli_one",
    description_connect_zinli_two: "description_connect_zinli_two",
    description_connect_zinli_three: "description_connect_zinli_three",
    connect: "connect",
    logout: "logout",
    kyc_cryptofacil_title: "kyc_cryptofacil_title",
    kyc_cryptofacil_description: "kyc_cryptofacil_description",
    init_validation: "init_validation",
    retry_request: "retry_request",
    update: "update",
    data_received: "data_received",
    data_validation: "data_validation",
    approval_data: "approval_data",
    kyc_step_title: "kyc_step_title",
    coin: "coin",
    network: "network",
    information_crypto_1: "information_crypto_1",
    rest_time: "rest_time",
    will_freeze_price: "will_freeze_price",
    if_not_do_tx_price_change: "if_not_do_tx_price_change",
    steps_to_pay_with_crypto: "steps_to_pay_with_crypto",
    select_crypto: "select_crypto",
    scan_qr_crypto_address: "scan_qr_crypto_address",
    make_payment_crypto: "make_payment_crypto",
    ready: "ready",
    how_pay_with_crypto: "how_pay_with_crypto",
    alert_disclaimer_crypto: "alert_disclaimer_crypto",
    consider_tax_from_crypto_wallet: "consider_tax_from_crypto_wallet",
    address: "address",
    confirm_payment: "confirm_payment",
    ended_acept_us: "ended_acept_us",
    terms_conditions: "terms_conditions",
    show_information_given: "show_information_given",
    second_step_title_details_crypto: "second_step_title_details_crypto",
    unknown: "unknown",
    our_partners: "our_partners",
    title_receive: "title_receive",
    title_steps_recharge: "title_steps_recharge",
    step_one_recharge: "step_one_recharge",
    step_two_recharge: "step_two_recharge",
    step_three_recharge: "step_three_recharge",
    step_four_recharge: "step_four_recharge",
    disclaimer_receive_two: "disclaimer_receive_two",
    subtitle_receive: "subtitle_receive",
    warning_time_freeze: "warning_time_freeze"
}

export const languageDefault = {
    title_charge_zinli_crypto: "Recarga Zinli con crypto", //EN: Recharge Zinli with crypto
    second_step_title: "Selecciona la moneda y red de tu preferencia y completa el pago", //EN: Select the currency and network of your preference and complete the payment
    email: "Correo electrónico", //EN: Email
    phone: "Teléfono", //EN: Phone
    enter_number: "Ingresar número", //EN: Enter number
    amount: "Monto", //EN: Amount
    next: "Siguiente", //EN: Next
    first_term_conditions: "Al finalizar esta solicitud acepta nuestros", //EN: By completing this application you accept our
    second_term_conditions: "y certifica que la información que ha proporcionado es completa y correcta", //EN: and certify that the information you have provided is complete and correct
    term_conditions: "Términos y condiciones", //EN: Terms and conditions
    title_home: "Recargar crypto nunca fue tan fácil", //EN: Recharge crypto has never been so easy
    title_first_button: "Recarga  Zinli con Crypto", //EN: Recharge Zinli with Crypto
    title_second_button: "Recarga Paguelofacil con Crypto", //EN: Recharge Paguelofacil with Crypto
    title_charge_pf_crypto: "Recarga Paguelofacil con crypto", //EN: Recharge Paguelofacil with crypto
    back_to_init: "Volver al inicio", //EN: Back to init
    title_login: "Iniciar sesión en PagueloFacil", //EN: Login in Paguelofacil
    scan_qr_pay_app: "Escanear QR y pagar desde el app", //EN: Scan QR and pay from the app
    password: "Contraseña", //EN: Password
    login: "Iniciar sesión", //EN: Login
    enter_amount: "Ingrese el monto a recargar", //EN: Enter the amount to recharge
    balanace_available: "Saldo disponible", //EN: Balance available
    title_sdk_pay_pf: "Elige la moneda y la red de tu preferencia y realiza el pago", //EN: Choose the currency and network of your preference and make the payment
    download_receipt: "Descargar comprobante", //EN: Download receipt
    proof_payment: "Comprobante de pago",
    proof_recurrent: "Comprobante de suscripción",
    proof_refunded: "Comprobante de reembolso",
    proof_parcial_refunded: "Comprobante de reembolso parcial",
    proof_captured: "Comprobante de captura",
    proof_recharge: "Comprobante de recarga",
    operation_code: "Código de operación",
    date_hour: "Fecha y hora",
    payment_method: "Método de pago",
    details: "Detalles",
    state: "Estado",
    total: "Total",
    method_crypto: "Cripto",
    pending: "Pendiente",
    aproved: "Aprobado",
    amount_recharged: "Monto recargado",
    commission: "Comisión",
    depend_network: "Depende de la red",
    state_suppler: "Estado con el proveedor",
    tx_id: "ID de transacción",
    disclaimer_amount_tax: "El costo de la recarga aplica una tarifa 3.50% + 0.50$ correspondientes al costo de procesamiento",
    title_home_cryptofacil: "Tu futuro comienza aquí",
    subtitle_home_cryptofacil: "Primera plataforma para recarga tu wallet con crypto en Panamá.",
    signup: "Registrarse",
    full_name: "Nombre completo",
    enter_full_name: "Ingresa nombre y apellido",
    create_account: "Crear cuenta",
    do_you_has_account: "Ya tienes una cuenta?",
    enter: "Ingresar",
    title_signup: "Crea tu cuenta en CryptoFacil",
    title_signup_validation_code: "Valida tu correo electronico",
    subtitle_signup: "Para comenzar a recargar tus wallets en CryptoFacil  completa los siguientes campos",
    subtitle_signup_validation_code: "Por favor, introduce el código de verificación de 12 dígitos enviado a",
    not_get_verification_code: "¿No recibiste el código?",
    resend: "Reenviar",
    validation_code: "Código de verificación",
    validate_characters_max: "Superaste la cantidad máxima de caracteres",
    validate_email: "Validar correo",
    do_not_you_has_account: "¿No tienes una cuenta?",
    title_login_cryptofacil: "Te damos la bienvenida  CryptoFacil",
    title_validation_code_login_cf: "Iniciar sesión en CyptoFacil",
    subtitle_validation_code_login_cf: "Te enviaremos un código a {email} para que puedas iniciar sesión.",
    subtitle_login_cryptofacil: "Ingresa tu correo para acceder a tu cuenta",
    hello: "Hola",
    connect_account_zinli: "Conecta tu cuenta de Zinli",
    first_step_title: "Vinculando tu cuenta de podrás fácilmente recargar tu wallet con crypto",
    description_connect_zinli_one: "Es fácil y rápido ",
    description_connect_zinli_two: "Solo pagas la comisión de la red",
    description_connect_zinli_three: "Recarga con multiples monedas",
    connect: "Conectar",
    logout: "Cerrar sesión",
    kyc_cryptofacil_title: "Formulario de conocimiento del cliente",
    kyc_cryptofacil_description: "Deberás realizar una validación en Binance para poder continuar operando con crypto, una vez finalizado podrás realizar depósitos.",
    init_validation: "Iniciar validación",
    retry_request: "Reintentar",
    update: "Actualizar",
    data_received: "Datos recibidos",
    data_validation: "Validación de los datos",
    approval_data: "Aprobación de los datos",
    kyc_step_title: "Valida tu información para continuar",
    coin: "Moneda",
    network: "Red",
    information_crypto_1: "Asegúrese de utilizar la red correcta, perderás tus activos si eliges la red incorrecta",
    rest_time: "Tiempo restante",
    will_freeze_price: "Congelaremos la tasa de intercambio por 10 minutos.",
    if_not_do_tx_price_change: "Si no haces la transacción en este período, la tasa cambiará con base al precio actual de la Crypto.",
    steps_to_pay_with_crypto: "Pasos para pagar con Cryptomonedas",
    select_crypto: "Selecciona la Cryptomoneda de tu preferencia",
    scan_qr_crypto_address: "Escanea el código QR o copia la dirección exactamente como está",
    make_payment_crypto: "Realiza el pago de tu moneda",
    ready: "Listo",
    how_pay_with_crypto: "¿Cómo pagar con cryptomonedas?",
    alert_disclaimer_crypto: "Al momento de hacer el pago debes tomar en cuenta la comisión de la red, el monto que verás a continuación es el monto a recibir sólo en caso de que recibamos el monto completo",
    consider_tax_from_crypto_wallet: "Debes tomar en cuenta la comisión de tu billetera o exchange, debemos recibir el pago exacto en el activo que hayas elegido",
    address: "Dirección",
    confirm_payment: "Confirmar pago",
    ended_acept_us: "Al finalizar esta solicitud acepta nuestros",
    terms_conditions: "Terminos y condiciones",
    show_information_given: "y certifica que la información que ha proporcionado es completa y correcta",
    second_step_title_details_crypto: "Escanea el código QR o copia el link para pagar desde tu billetera Crypto",
    unknown: "Desconocido",
    our_partners: "Nuestros colaboradores",
    title_receive: "Detalles de Recarga",
    title_steps_recharge: "Indicaciones",
    step_one_recharge: "Ingresa a tu wallet o exchange.",
    step_two_recharge: "Escanea el código QR o usa la dirección que te proporcionamos.",
    step_three_recharge: "Asegúrate de seleccionar la misma red para que la recarga se procese correctamente.",
    step_four_recharge: "Completa la transacción. En pocos minutos los fondos se reflejarán en tu cuenta Zinli.",
    disclaimer_receive_two: "Debes tomar en cuenta la comisión de tu billetera o exchange, debemos recibir el pago exacto en el activo que hayas elegido",
    subtitle_receive: "Hemos recibido tu solicitud de recarga ahora debes finalizar en tu wallet o exchange.",
    warning_time_freeze: "Congelaremos la tasa de intercambio hasta {date}. Si no haces la transacción en este período, la tasa cambiará con base al precio actual de la Crypto."
}
